import { auth } from './auth';

export default async function authorizedFetch(url, options = {}) {
  const token = auth.getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res = await fetch(url, { ...options, headers, credentials: 'include' });

  if (res.status === 401 && !auth.isAuthUrl(url)) {
    auth.logout();
    // Optionally throw to stop downstream code:
    // throw new Error('Unauthorized');
  }

  return res;
}